import { render } from "./InvestmentsWorldEconRev.vue?vue&type=template&id=5859c5d2&scoped=true"
import script from "./InvestmentsWorldEconRev.vue?vue&type=script&lang=js"
export * from "./InvestmentsWorldEconRev.vue?vue&type=script&lang=js"

import "./InvestmentsWorldEconRev.vue?vue&type=style&index=0&id=5859c5d2&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5859c5d2"]])

export default __exports__